<template>
  <div id='tabbar'>
	  <a  @click='toRouter'>
	      <!-- <img src="../assets/tab-bar/nav-cart-disable@2x.png" alt=""> -->
	      <!-- <img  :src="item.img" alt=""/> -->
	      <div>
	          <img src="@/assets/tab-bar/nav-home-disable@2x.png"  alt="" />

	      </div>
	      <div>首页</div>
	  </a>
          <router-link :to="item.name"  v-for="item in computedRouterList" >
              <!-- <img src="../assets/tab-bar/nav-cart-disable@2x.png" alt=""> -->
              <!-- <img  :src="item.img" alt=""/> -->
              <div>
                  <img :src="item.imgActive" v-if='item.active' alt="" />
                  <img :src="item.img" v-else alt="" />
              </div>
              <div >{{item.title}}</div>
          </router-link>
    <router-view/>
  </div>
  
</template>

<script>
export default {
  name: 'tabbar',
  props: {
    msg: String
  },
  computed: {
 
    computedRouterList () {
      this.routerList.forEach((item)=>{
        item.active=false
        if(item.name == this.msg){
          item.active=true
          console.log(this.msg)
        }
      })
      return this.routerList
    }
  },
  data:()=>{
    return{
      routerList:[
     
	  {title:"产品",name:"/",imgActive:require("@/assets/tab-bar/nav-product@2x.png"),img:require("@/assets/tab-bar/nav-product-disable@2x.png")},
      {title:"报告",name:"/report",imgActive:require("@/assets/tab-bar/nav-report@2x.png"),img:require("@/assets/tab-bar/nav-report-disable@2x.png")},
      {title:"橘袋",name:"/cart",imgActive:require("@/assets/tab-bar/nav-cart@2x.png"),img:require("@/assets/tab-bar/nav-cart-disable@2x.png")},
      {title:"我的",name:"/mineH5",imgActive:require("@/assets/tab-bar/nav-me@2x.png"),img:require("@/assets/tab-bar/nav-me-disable@2x.png")},
      ]
    }
  },
  methods: {
   toRouter(){
	   // window.open("https://www.nutri-packs.cn/");
	   window.location.href="https://www.nutri-packs.cn/"; 
   },
  },


}
</script>

<style scoped lang="scss">
#tabbar{
  display: flex;
  width: 100%;
  position: fixed;
  z-index: 999;
  left: 0;
  bottom: 0;
  border-top: 1px solid #CFCFCF;
  background-color: #fff;
  a {
    font-weight: bold;
    color: #CFCFCF;
    text-decoration: none;
    width: 25%;
    height: 1.1rem;
    font-size: 0.24rem;
    font-weight: 500;
    display: flex;
    flex-direction:column;
    justify-content:center;
    div{
      text-align: center;
    }
    img{
       width: 0.6rem;
    }
    &.router-link-exact-active {
      color: #C25E4D;
      text-decoration: none;
    }
  }

}

</style>